module.exports = __webpack_public_path__ + "static/Chinmay Patel.065bd459.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Chinmay Patel.jpg
// module id = 1208
// module chunks = 6166952557895